import { render, staticRenderFns } from "./PaymentContractsDetailsTab.vue?vue&type=template&id=cfadee26&"
import script from "./PaymentContractsDetailsTab.vue?vue&type=script&lang=js&"
export * from "./PaymentContractsDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports